import React, { useState, useEffect, Fragment } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";

const Comentarios = ({ parentCallback, disabled }) => {
    let { id } = useParams();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const [comentarios, setComentarios] = useState([]);
    const [commentText, setCommentText] = useState("");
    const [commentDate, setCommentDate] = useState("");

    //console.log(errors);

    parentCallback(comentarios);

    useEffect(() => {
        if (id) {
            let url = new URL(`${process.env.REACT_APP_API_URL}/comentarios`);
            let params = { id: id };
            url.search = new URLSearchParams(params).toString();
            fetch(url)
                .then((res) => res.json())
                .then((data) => {
                    // console.log(data);
                    setComentarios(data);
                })
                .catch(console.log);
        }
    }, []);
    return (
        <React.Fragment>
            <div className="card my-5">
                <h5 className="card-header">Comentarios:</h5>
                <div className="card-body">
                    <table className="table table-sm table-hover">
                        <thead>
                            <tr>
                                <th className="col-8">Comentario</th>
                                <th className="col-2">Fecha</th>
                                <th className="col-2">Agregado por</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comentarios.length > 0
                                ? comentarios.map((i) => (
                                    <tr>  
                                        <td>{i.commentText}</td>
                                        <td>{(i.commentDate.substring(0, 16)).replace('T', ' ')}</td>
                                        <td>{i.usu_username}</td>
                                    </tr>
                                ))
                                : ""}
                        </tbody>
                    </table>

                    {!disabled && (
                        <div className="card mt-5">
                            <span className="card-header">Nuevo Comentario</span>
                            <div className="card-body">
                                <div className="row py-2 align-items-end">
                                    <div className="form-group col-md-10">
                                        <label htmlFor="comentario">Comentario</label>
                                        <input
                                            type="text"
                                            onChange={(e) => {
                                                setCommentText(e.target.value);
                                                setCommentDate(
                                                    new Date().getFullYear() +
                                                    "-" +
                                                    (new Date().getMonth() + 1) +
                                                    "-" +
                                                    new Date().getDate() +
                                                    " " +
                                                    new Date().getHours() +
                                                    ":" +
                                                    new Date().getMinutes() 
                                                );
                                            }}
                                            className="form-control"
                                            id="comentario"
                                            placeholder="Comentario"
                                        />
                                    </div>
                                    <div className="col-2">
                                        <button
                                            disabled={commentText === ""}
                                            type="button"
                                            onClick={() => {
                                                setComentarios((comentarios) => [
                                                    ...comentarios,
                                                    { commentText, commentDate },
                                                ]);
                                                document.getElementById("comentario").value = "";
                                                setCommentText("");
                                                setCommentDate("");
                                            }}
                                            className="btn btn-success col-12"
                                        >
                                            Agregar comentario
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Comentarios;
